import React, { useEffect, useState, useRef } from "react";
import PropTypes from "prop-types";
import Header3 from "../../components/header/Header3";
import Footer2 from "../../components/footer2";
import Gotop from "../../components/gotop";
import { Link, NavLink } from "react-router-dom";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";
import { Collapse } from "react-collapse";
import logo from "../../assets/siteimages/logo.png";
import axios from "axios";
import { Helmet } from "react-helmet-async";
import { FaPhoneAlt, FaWhatsapp } from "react-icons/fa"; // Import icons
import { useParams } from "react-router-dom";
import Breadcrumbuser from "../../components/breadcrumbuser";
import { useContext } from "react";
import { AuthContext } from "../../AuthContext";
import "../../assets/FakeTable.css";

Invoice.propTypes = {};

function Invoice(props) {
  const [toggle, setToggle] = useState({
    key: "",
    status: false,
  });
  const [isShowMobile, setShowMobile] = useState(false);

  const handleToggle = (key) => {
    if (toggle.key === key) {
      setToggle({
        status: false,
      });
    } else {
      setToggle({
        status: true,
        key,
      });
    }
  };

  const handleMobile = () => {
    const getMobile = document.querySelector(".menu-mobile-popup");
    setShowMobile(!isShowMobile);
    !isShowMobile
      ? getMobile.classList.add("modal-menu--open")
      : getMobile.classList.remove("modal-menu--open");
  };

  useEffect(() => {
    const WOW = require("wowjs");
    window.wow = new WOW.WOW({
      live: false,
    });
    window.wow.init();
  }, []);

  const [categories, setCategories] = useState([]);
  const [categoriesnew, setCategoriesnew] = useState([]);
  const [categoriesnew1, setCategoriesnew1] = useState([]);
   const [categoriesnew2, setCategoriesnew2] = useState([]);

  useEffect(() => {
    fetchCategories();
    fetchCategoriesnew();
    fetchCategoriesnew1();
     fetchCategoriesnew2();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/blogcategoriessort"); // Adjust the URL if needed
      setCategories(response.data);
    } catch (error) {
      console.error("Error fetching blog categories:", error);
    }
  };

  const fetchCategoriesnew = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/horoscopecategoriessort"); // Adjust the URL if needed
      setCategoriesnew(response.data);
    } catch (error) {
      console.error("Error fetching horoscope categories:", error);
    }
  };

  const fetchCategoriesnew1 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/astrocategoriessort"); // Adjust the URL if needed
      setCategoriesnew1(response.data);
    } catch (error) {
      console.error("Error fetching astro categories:", error);
    }
  };

   const fetchCategoriesnew2 = async () => {
    try {
      const response = await axios.get("https://adhigyanam-e92bf1bbbdb1.herokuapp.com/coursecategoriessort"); // Adjust the URL if needed
      setCategoriesnew2(response.data);
    } catch (error) {
      console.error("Error course categories:", error);
    }
  };

const [showSearch, setShowSearch] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");
   const { logout } = useContext(AuthContext);

 const { clientId } = useParams();
 const [userId, setUserId] = useState(null);

    useEffect(() => {
      const storedUserId = localStorage.getItem("userId");
      if (storedUserId) {
        setUserId(storedUserId);
      }
    }, []);

  const [userData, setUserData] = useState({
  fullName: "",
  email: "",
  contactNo: ""
    });

useEffect(() => {
  const fetchUserData = async () => {
    try {
      const storedUserId = localStorage.getItem("userId");
      if (!storedUserId) return;

      const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getuserbyid/${storedUserId}`);
      if (response.data) {
        setUserData({
          fullName: response.data.Named || "",
          email: response.data.Email || "",
          contactNo: response.data.Cno || ""
        });
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  fetchUserData();
}, []);

const [orders, setOrders] = useState([]);

  useEffect(() => {
    if (clientId) {
      axios
        .get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/api/invoiceorders/${clientId}`)
        .then((res) => setOrders(res.data))
        .catch((err) => console.error(err));
    }
  }, [clientId]);

  const [userDatanew, setUserDatanew] = useState({
  Price1: "",
  Tid: "",
  Dated: "",
  DiscountAmount: "",
  Netamount: ""
    });

    useEffect(() => {
  const fetchInvoiceData = async () => {
    try {
      if (!clientId) return;
      const response = await axios.get(`https://adhigyanam-e92bf1bbbdb1.herokuapp.com/getinvoicebyid/${clientId}`);
      if (response.data) {
        setUserDatanew({
          Price1: response.data.Price1 || "",
          Tid: response.data.Tid || "",
          Dated: response.data.Dated || "",
          DiscountAmount: response.data.DiscountAmount || "",
          Netamount: response.data.Netamount || ""
        });
      }
    } catch (error) {
      console.error("Error fetching invoice data:", error);
    }
  };

  fetchInvoiceData();
}, []);

const thStyle = {
  padding: '10px',
  textAlign: 'left',
  borderBottom: '1px solid #ccc',
  fontWeight: 'bold'
};

const tdStyle = {
  padding: '10px',
  borderBottom: '1px solid #eee',
  fontSize: '13px',
  lineHeight: '1.6'
};

 const invoiceRef = useRef();

   
  return (
    <>
    <Helmet>
            <title>Download Invoice - Adhigyanam | Sauntesthyam LLP</title>
          </Helmet>
          <div className="menu-mobile-popup">
        <div className="modal-menu__backdrop" onClick={handleMobile}></div>
        <div className="widget-filter">
          <div className="mobile-header">
            <div id="logo" className="logo">
              <Link to="/home">
                <img className="site-logo" src={logo} alt="Image" />
              </Link>
            </div>
            <Link className="title-button-group" onClick={handleMobile}>
              <i className="icon-close"></i>
            </Link>
          </div>

        <Tabs className="tf-tab">
            

            <div className="content-tab">
              <TabPanel className="header-ct-center menu-moblie animation-tab">
                <div className="nav-wrap">
                  <nav className="main-nav mobile">
                    <ul id="menu-primary-menu" className="menu">
                    <li className="menu-item ">
                        <Link
                          to="/home"
                          className="iteam-menu"
                          
                        >
                          Home
                        </Link>
                      </li>
                      {/* <li className="menu-item ">
                        <Link
                          to="/about"
                          className="iteam-menu"
                          
                        >
                          About Us
                        </Link>
                      </li> */}

                   

                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("services");
                          }}
                        >
                          eConsultation
                        </Link>
                        <Collapse isOpened={toggle.key === "services"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "services" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew1.length > 0 ? (
          categoriesnew1.map((categorynew1, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/category-details/${categorynew1.Id}`}>{categorynew1.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                     
                      <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("courses");
                          }}
                        >
                          eLearning
                        </Link>
                        <Collapse isOpened={toggle.key === "courses"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "courses" ? "block" : "none"
                              }`,
                            }}
                          >
                           {categoriesnew2.length > 0 ? (
          categoriesnew2.map((categoriesnew2, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/course-category-details/${categoriesnew2.Id}`}>{categoriesnew2.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}
                            
                          </ul>
                        </Collapse>
                      </li>
                    <li className="menu-item ">
                        <Link
                          to="/epooja"
                          className="iteam-menu"
                          
                        >
                          ePooja
                        </Link>
                      </li>
                     
                         <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("horoscope");
                          }}
                        >
                         Horoscope
                        </Link>
                        <Collapse isOpened={toggle.key === "horoscope"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "horoscope" ? "block" : "none"
                              }`,
                            }}
                          >

 {categoriesnew.length > 0 ? (
          categoriesnew.map((categorynew, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/horoscopes/${categorynew.Id}`}>{categorynew.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                       <li className="menu-item menu-item-has-children-mobile">
                        <Link
                          to="#"
                          className="iteam-menu"
                          onClick={() => {
                            handleToggle("blog");
                          }}
                        >
                          Blog
                        </Link>
                        <Collapse isOpened={toggle.key === "blog"}>
                          <ul
                            className="sub-menu-mobile"
                            style={{
                              display: `${
                                toggle.key === "blog" ? "block" : "none"
                              }`,
                            }}
                          >

 {categories.length > 0 ? (
          categories.map((categories, index) => (
            <li key={index} className="menu-item menu-item-mobile">
              <Link to={`/blog-category-details/${categories.Id}`}>{categories.Named}</Link> {/* 'Named' column from the database */}
            </li>
          ))
        ) : (
          <li className="menu-item menu-item-mobile">
            <span>No categories available</span>
          </li>
        )}

                          </ul>
                        </Collapse>
                      </li>
                      <li className="menu-item ">
                        <Link
                          to="/support"
                          className="iteam-menu"
                          
                        >
                         FAQ & Support
                        </Link>
                      </li>
                    </ul>
                  </nav>
                </div>
              </TabPanel>

           
            </div>
          </Tabs>
          <div className="header-customize-item button" style={{padding: "0px 0px",
    background:"none",
    backgroundColor:"#14a077",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "white",
    borderColor: "transparent",
    textTransform: "capitalize"}}>
            <Link to="/userdashboard" style={{color: "#ffffff"}}>Dashboard</Link>
          </div>
           
          

           <div className="mobile-footer">
            <div className="icon-infor d-flex aln-center">
              <div className="icon">
                <span className="icon-call-calling">
                  <span className="path1"></span>
                  <span className="path2"></span>
                  <span className="path3"></span>
                  <span className="path4"></span>
                </span>
              </div>
              <div className="content">
                <p>Need help? 24/7</p>
                <h6>
                   <Link to={`tel:918960708425`}>+91-8960708425</Link>
                </h6>
              </div>
            </div>
            <p><b>Corporate Address</b>: Sauntesthyam LLP, Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</p>
            <p style={{marginTop:"15px"}}><b>Write To Us On</b>: <Link to={`mailto:sauntesthyam@gmail.com`} style={{textDecoration:"underline"}}>sauntesthyam@gmail.com</Link>, <Link to={`mailto:info@adhigyanam.com`}  style={{textDecoration:"underline"}}>info@adhigyanam.com</Link></p>
            <div className="wd-social d-flex aln-center" style={{marginTop:"15px"}}>
      <ul className="list-social d-flex aln-center">
                                     <li><Link to="https://www.facebook.com/Adhigyanam"><i className="icon-facebook"></i></Link></li>
                                     <li><Link to="https://www.instagram.com/the_vedic_astro"><i className="icon-instagram1"></i></Link></li>
                                     <li><Link to="https://x.com/adhigyanam"><i className="icon-twitter"></i></Link></li>
                                 </ul>
    </div>
          </div>
          <div >
                      <button onClick={logout} className="header-customize-item button" style={{padding: "12px 20px",
    background:"none",
    backgroundColor:"white",
    borderRadius: "4px",
    fontWeight: "700",
    fontSize: "16px",
    lineHeight: "21px",
    color: "black",
    borderColor: "red",
    textTransform: "capitalize"}}>Logout</button>
                    </div>
        </div>
      </div>
 

      
      <Header3 clname="act1" handleMobile={handleMobile} />
        <Breadcrumbuser title="Download Invoice" />

         <section style={{ paddingTop: "20px", marginBottom:"25px" }}>
              <div className="tf-container">
                <div className="row"  style={{maxWidth:"1200px", margin:"auto", padding:"auto"}}>
 <div id="invoice" ref={invoiceRef}>
           <div style={{
  maxWidth: '700px',
  margin: '30px auto',
  padding: '20px',
  fontFamily: 'Arial, sans-serif',
  fontSize: '14px',
  border: '1px solid #ddd',
  borderRadius: '8px',
  backgroundColor: '#fff',
  boxShadow: '0 0 10px rgba(0,0,0,0.1)'
}}>
<div className="col-lg-12 col-md-12" style={{textAlign:"center"}}>
        <img src={require ('../../assets/siteimages/logo.jpeg')} style={{width:"185px", height:"auto", margin:"auto", padding:"auto", paddingTop:"15px", paddingBottom:"0px"}} alt="images" />
        </div>
  <table style={{ width: '100%', borderCollapse: 'collapse' }}>
    <tbody>
      <tr>
        <td colSpan="2">
          <h6 style={{ marginBottom: '10px', textAlign: 'center', borderBottom: '2px solid #000', paddingBottom: '10px', fontSize:"18px" }}>
            Sauntesthyam LLP
            <br/><span style={{fontSize:"13px", fontWeight:"normal"}}>Munshi Puliya, Indira Nagar, Lucknow, Uttar Pradesh - 226016</span>
          </h6>
        </td>
      </tr>
      <tr>
        <td style={{ width: '50%', verticalAlign: 'top', padding: '10px' }}>
          <p style={{ marginBottom: '5px', fontSize:"17px", fontWeight:"bold" }}>Billed To</p>
          <p style={{ margin: '0' }}>
            <strong>{userData.fullName}</strong><br />
            {userData.email}<br />
            {userData.contactNo}
          </p>
        </td>
        <td style={{ width: '50%', verticalAlign: 'top', padding: '10px' }}>
          <p style={{ marginBottom: '5px', fontSize:"17px", fontWeight:"bold" }}>Invoice Details</p>
          <p style={{ margin: '0' }}>
            <strong>Dated:</strong> {userDatanew.Dated}<br />
            <strong>Transaction ID:</strong> {userDatanew.Tid}
          </p>
        </td>
      </tr>
      <tr>
        <td colSpan="2" style={{ paddingTop: '20px' }}>
          <table style={{
            width: '100%',
            borderCollapse: 'collapse',
            border: '1px solid #ccc'
          }}>
            <thead>
              <tr style={{ backgroundColor: '#f5f5f5' }}>
                <th style={thStyle}>Course</th>
                <th style={thStyle}>Validity (Days)</th>
                <th style={thStyle}>Price (INR)</th>
              </tr>
            </thead>
            <tbody>
              {orders.map((order, index) => (
                <tr key={index}>
                  <td style={tdStyle}>{order.Coursename}</td>
                  <td style={tdStyle}>{order.Validity}</td>
                  <td style={tdStyle}>{order.Courseprice}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </td>
      </tr>
      <tr>
        <td colSpan="2" style={{ paddingTop: '20px', textAlign: 'right' }}>
        <p><b>Sub Total</b>: {userDatanew.Price1} INR</p>
         <p><b>Discount</b>: {userDatanew.DiscountAmount} INR</p>
          <h6 style={{fontSize:"16px", marginTop:"10px"}}>Total Paid: <span style={{ color: '#000' }}>{userDatanew.Netamount} INR</span></h6>
        </td>
      </tr>
      
    </tbody>
  </table>
  <div style={{ marginTop: '15px', fontSize: '13px' }}>
  <h4 style={{ marginBottom: '10px', fontSize:"14px" }}>Terms & Conditions</h4>
  <ul style={{ paddingLeft: '20px', lineHeight: '1.6',
    paddingLeft: '20px',
    lineHeight: '1.6',
    listStyleType: 'disc',
    listStylePosition: 'outside'
  }}>
    <li>Validity takes effect as soon as the course is purchased.</li>
    <li>Access to course content is non-transferable and intended solely for the registered user.</li>
    <li>No refunds will be issued once the course has been accessed.</li>
    <li>All course materials are subject to copyright and cannot be redistributed or reused without permission.</li>
    <li>Technical support is available during working hours for any access-related issues.</li>
    <li>Prices are inclusive of all applicable taxes unless stated otherwise.</li>
    <li>It is the user’s responsibility to ensure stable internet connectivity for smooth access.</li>
    <li>Completion certificates, if applicable, are issued only after successful completion of the course.</li>
  </ul>
</div>
</div>
</div>
<div style={{width:"100%", textAlign:"center", marginBottom: '20px'}}><button
        onClick={() => window.print()}
        style={{
          margin:"auto",
          padding: '20px 20px',
          backgroundColor: 'green',
          color: 'white',
          border: 'none',
          borderRadius: '5px',
          cursor: 'pointer', fontWeight:"bold", width:"200px"
        }}
      >
        Download / Print
      </button></div>

      {/* Print-Specific CSS */}
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }

            #invoice, #invoice * {
              visibility: visible;
            }

            #invoice {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
            }

            button {
              display: none;
            }
          }
        `}
      </style>

                    
                </div>
                </div>
                </section>
       
        
     
      
        <div
                  className="floating-buttons"
                  style={{
                    position: "fixed",
                    bottom: "20px",
                    left: "20px",
                    zIndex: "1000",
                    display: "flex",
                    flexDirection: "column",
                    gap: "10px",
                  }}
                >
                  {/* Call Button */}
                  <a
                    href={`tel:918960708425`}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#007BFF",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaPhoneAlt />
                  </a>
                
                  {/* WhatsApp Button */}
                  <a
                    href={`https://wa.me/918960708425`}
                    target="_blank"
                    rel="noopener noreferrer"
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      width: "60px",
                      height: "60px",
                      backgroundColor: "#25D366",
                      borderRadius: "50%",
                      boxShadow: "0px 4px 10px rgba(0,0,0,0.2)",
                      color: "white",
                      fontSize: "28px",
                    }}
                  >
                    <FaWhatsapp />
                  </a>
                </div>
      <Footer2 />
      <Gotop />
    </>
  );
}

export default Invoice;
